import React from "react";
import "./landing.scss";

/* REDUX */
import { useDispatch } from "react-redux";
import { showModal } from "../../redux/actions";

/* ASSETS */
import BG from "../../assets/kzvb_wallpaper.jpg";

const Landing = () => {
  const dispatch = useDispatch();

  return (
    <main className='landing'>
      <div className='landing__video'>
        <div className='landing__video__layer'></div>
        <img src={BG} alt='' />
      </div>
      <div className='landing__content'>
        <h1 className='landing__content__title'>Obleuteforum der KZVB</h1>
        <p className='landing__content__subtitle'>
          Treten Sie einem der verfügbaren Räume bei um an einer
          Gruppenkonversation teilzunehmen.
        </p>
        <p className='mt-5'>
          Beim Betreten eines Themenraumes stimmen Sie zugleich den{" "}
          <span
            className='landing__terms'
            onClick={() =>
              dispatch(showModal("Nutzungsbedingungen", "terms", "m"))
            }
          >
            Nutzungsbedingungen
          </span>{" "}
          des Obleuteforums der KZVB zu.
        </p>
      </div>
    </main>
  );
};

export default Landing;
